import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _toArray from "@babel/runtime/helpers/toArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DIMENSIONS } from 'utils/image/getPictureUrl';
import Box from 'components/Box';
import Button from 'components/Button';
import Flex from 'components/Flex';
import Stack from 'components/Stack';
import { TinyHorizontalCard } from 'components/ContentCards';
import { useDisclosure } from 'components/Disclosure';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function switchFirstTwoItems(items) {
  var _items = _toArray(items),
    first = _items[0],
    second = _items[1],
    rest = _arrayLikeToArray(_items).slice(2);
  return [second, first].concat(_toConsumableArray(rest));
}
function RelatedPlaylists(_ref) {
  var _ref$playlists = _ref.playlists,
    playlists = _ref$playlists === void 0 ? [] : _ref$playlists,
    playlistId = _ref.playlistId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useDisclosure = useDisclosure(),
    isVisible = _useDisclosure.isVisible,
    toggle = _useDisclosure.toggle,
    buttonProps = _useDisclosure.buttonProps,
    contentProps = _useDisclosure.contentProps;

  // We don't want the parent playlist to be in the first spot,
  // so we switch its position with the second one if necessary
  var isFirstPlaylistParent = playlists[0].id === playlistId;
  var orderedPlaylists = isFirstPlaylistParent ? switchFirstTwoItems(playlists) : playlists;
  var playlistsToShow = isVisible ? orderedPlaylists : orderedPlaylists.slice(0, 1);
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: "xxs",
    px: "m",
    py: "s",
    children: [/*#__PURE__*/_jsxs(Flex, {
      mt: "-xxs",
      children: [/*#__PURE__*/_jsx(Box, {
        grow: true,
        shrink: true,
        as: "h2",
        fontSize: "s",
        children: t('asset_in_playlists_colon', {
          count: playlists.length
        })
      }), playlists.length > 1 && /*#__PURE__*/_jsx(Box, {
        mr: "-xs",
        children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
          onClick: toggle,
          variant: "transparent",
          size: "small",
          children: isVisible ? t('actions_show_less') : t('actions_show_more')
        }))
      })]
    }), /*#__PURE__*/_jsx(Stack, {
      spacing: "xs",
      id: contentProps.id,
      children: playlistsToShow.map(function (_ref2) {
        var id = _ref2.id,
          title = _ref2.title,
          location = _ref2.location,
          pictureUrl = _ref2.pictureUrl;
        return /*#__PURE__*/_jsx(TinyHorizontalCard, {
          title: title,
          subtitle: id === playlistId && t('you_are_here'),
          link: location,
          imageSource: pictureUrl ? "".concat(pictureUrl, "/").concat(DIMENSIONS.TINY_CARD) : '',
          icon: "playlist"
        }, id);
      })
    })]
  });
}
export default RelatedPlaylists;